/**
 * cmdk filter: every search word must appear in the label (underscores read as spaces), or failing
 * that in the phase or description keywords, which rank lower.
 */
export function scoreCategorySearch(
  label: string,
  search: string,
  keywords: string[] = [],
): number {
  const words = search.toLowerCase().split(/\s+/).filter(Boolean)
  if (words.length === 0) return 1

  const labelText = `${label} ${label.replace(/_/g, ' ')}`.toLowerCase()
  if (words.every((word) => labelText.includes(word))) return 1

  const allText = `${labelText} ${keywords.join(' ').replace(/_/g, ' ')}`.toLowerCase()
  return words.every((word) => allText.includes(word)) ? 0.5 : 0
}
